import { atom } from "recoil";
import { CHEST_PRIZE_TYPE_OPTIONS } from "../helpers/chestPrizeTypes";

export const chestPrizeEditModalStore = atom({
	key: "chestPrizeEditModalStore",
	default: {
		show: false,
		loaded: true,
		id: null,
		name: "",
		type: null,
		typeOptions: CHEST_PRIZE_TYPE_OPTIONS,
		chestRewards: [],
	},
});
